import { Button, CILabel, Input } from 'ccs-ui-components';
import { Dispatch, SetStateAction, useEffect, useReducer } from 'react';
import { useTranslation } from 'react-i18next';
import { IServiceOperationValidationModel } from '../../../../../../../models';
import classes from './RequestResponseAttribute.module.scss';
import { RequestResponseItems } from './RequestResponseItems';
import { REQUEST_RESPONSE_ENCRYPTION_ACTIONS, getRequestResponseEncryptionStateReducer, requestResponseFormInitialState } from './RequestResponseStateManager';

interface IRequestResponseAttribute{
  handleInputChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    isEditOrCreate: boolean;
    serviceOpsFormData: IServiceOperationValidationModel;
    requestAttributeList:string[];
    responseAttributeList:string[];
    setRequestAttributeList: Dispatch<SetStateAction<string[]>>;
    setResponseAttributeList: Dispatch<SetStateAction<string[]>>;
}

export const requestDuplicateChecker = (serviceOpsFormData: IServiceOperationValidationModel, isDuplicate: string) => {
  let requestDuplicateError = '';
  if (!serviceOpsFormData.requestAttributes.isValid && serviceOpsFormData.requestAttributes.value && !isDuplicate) requestDuplicateError = String(serviceOpsFormData.requestAttributes.error);
  else if (isDuplicate) requestDuplicateError = isDuplicate;
  return requestDuplicateError;
};

 export const requestAddBtnChecker = (serviceOpsFormData: IServiceOperationValidationModel, isDuplicate: string) => {
  let validity = false;
  if (!serviceOpsFormData.requestAttributes.value || !serviceOpsFormData.requestAttributes.isValid || isDuplicate) {
    validity = true;
  }
  return validity;
};

export const responseDuplicateChecker = (serviceOpsFormData: IServiceOperationValidationModel, isDuplicate: string) => {
  let responseDuplicateError = '';
  if (!serviceOpsFormData.responseAttributes.isValid && serviceOpsFormData.responseAttributes.isTouched && !isDuplicate) responseDuplicateError = String(serviceOpsFormData.responseAttributes.error);
  else if (isDuplicate) responseDuplicateError = isDuplicate;
  return responseDuplicateError;
};

 export const responseAddBtnChecker = (serviceOpsFormData: IServiceOperationValidationModel, isDuplicate: string) => {
  let validity = false;
  if (!serviceOpsFormData.responseAttributes.value || !serviceOpsFormData.responseAttributes.isValid || isDuplicate) {
    validity = true;
  }
  return validity;
};
export const RequestResponseAttribute = ({
  handleInputChange,
    isEditOrCreate,
    serviceOpsFormData,
    requestAttributeList,
    responseAttributeList,
    setResponseAttributeList,
    setRequestAttributeList

}:IRequestResponseAttribute) => {
    const { t: translate } = useTranslation();
    const [formData, dispatchRequestResponseState] = useReducer(getRequestResponseEncryptionStateReducer, requestResponseFormInitialState);
    /**
   * @method onRequestDeleteHandler
   * @description Handles the deletion of an item from the requestAttributeList.
   * @param index - The index of the item to be deleted.
   */
  const onRequestDeleteHandler = (index: number) => {
    const itemArray = [...requestAttributeList];
    itemArray.splice(index, 1);
    setRequestAttributeList(itemArray);
  };

    /**
   * @method onResponseDeleteHandler
   * @description Handles the deletion of an item from the responseAttributeList.
   * @param index - The index of the item to be deleted.
   */
  const onResponseDeleteHandler = (index: number) => {
    const itemArray = [...responseAttributeList];
    itemArray.splice(index, 1);
    setResponseAttributeList(itemArray);
  };

  const requestAttributeInvalidity = (!serviceOpsFormData.requestAttributes.isValid && serviceOpsFormData.requestAttributes.value.length > 0) || formData.requestDuplicateError.length > 0;

  const responseAttributeInvalidity = (!serviceOpsFormData.responseAttributes.isValid && serviceOpsFormData.responseAttributes.value.length > 0) || formData.responseDuplicateError.length > 0;

   // To toggle error on requestAttribute input
   useEffect(() => {
    const objRequestAttribute = requestAttributeList.filter((item) => item.toLocaleUpperCase() === serviceOpsFormData.requestAttributes.value.toLocaleUpperCase());
    if (objRequestAttribute.length) {
      dispatchRequestResponseState({
        type: REQUEST_RESPONSE_ENCRYPTION_ACTIONS.SET_REQUEST_DUPLICATE_ERROR,
        requestDuplicateErrorPayload: { requestDuplicateError: String(translate('serviceOperationsError.request_attribute_duplicate')) }
      });
    } else {
      dispatchRequestResponseState({
        type: REQUEST_RESPONSE_ENCRYPTION_ACTIONS.SET_REQUEST_DUPLICATE_ERROR,
        requestDuplicateErrorPayload: { requestDuplicateError: '' }
      });
    }

    dispatchRequestResponseState({
      type: REQUEST_RESPONSE_ENCRYPTION_ACTIONS.SET_REQUEST_INPUT_ERROR,
      requestInputErrPayload: { requestInputErr: requestDuplicateChecker(serviceOpsFormData, formData.requestDuplicateError) }
    });
    dispatchRequestResponseState({
      type: REQUEST_RESPONSE_ENCRYPTION_ACTIONS.SET_REQUEST_BUTTON_INVALID,
      requestBtnInvalidPayload: { requestBtnInvalid: requestAddBtnChecker(serviceOpsFormData, formData.requestDuplicateError) }
    });
  }, [serviceOpsFormData, requestAttributeList, formData.requestDuplicateError, formData.requestBtnInvalid]);

 // To toggle error on responseAttribute input
  useEffect(() => {
    const objResponseAttribute = responseAttributeList.filter((item) => item.toLocaleUpperCase() === serviceOpsFormData.responseAttributes.value.toLocaleUpperCase());
    if (objResponseAttribute.length) {
      dispatchRequestResponseState({
        type: REQUEST_RESPONSE_ENCRYPTION_ACTIONS.SET_RESPONSE_DUPLICATE_ERROR,
        responseDuplicateErrorPayload: { responseDuplicateError: String(translate('serviceOperationsError.response_attribute_duplicate')) }
      });
    } else {
      dispatchRequestResponseState({
        type: REQUEST_RESPONSE_ENCRYPTION_ACTIONS.SET_RESPONSE_DUPLICATE_ERROR,
        responseDuplicateErrorPayload: { responseDuplicateError: '' }
      });
    }

    dispatchRequestResponseState({
      type: REQUEST_RESPONSE_ENCRYPTION_ACTIONS.SET_RESPONSE_INPUT_ERROR,
      responseInputErrPayload: { responseInputErr: responseDuplicateChecker(serviceOpsFormData, formData.responseDuplicateError) }
    });
    dispatchRequestResponseState({
      type: REQUEST_RESPONSE_ENCRYPTION_ACTIONS.SET_RESPONSE_BUTTON_INVALID,
      responseBtnInvalidPayload: { responseBtnInvalid: responseAddBtnChecker(serviceOpsFormData, formData.responseDuplicateError) }
    });
  }, [serviceOpsFormData, responseAttributeList, formData.responseDuplicateError, formData.responseBtnInvalid]);

  /**
   * @method onRequestAddClickHandler
   * @description Handles the click event when the "Add" button is clicked.
   */
  const onRequestAddClickHandler = () => {
    const requestItemArray = [...requestAttributeList];
    requestItemArray.push(serviceOpsFormData.requestAttributes.value);
    setRequestAttributeList(requestItemArray);
    serviceOpsFormData.requestAttributes.value = '';
    serviceOpsFormData.requestAttributes.isValid = true;
  };

  const onResponseAddClickHandler = () => {
    const responseItemArray = [...responseAttributeList];
    responseItemArray.push(serviceOpsFormData.responseAttributes.value);
    setResponseAttributeList(responseItemArray);
    serviceOpsFormData.responseAttributes.value = '';
    serviceOpsFormData.responseAttributes.isValid = true;
  };

    return (
      <>
        <div className={classes['encryption-field-input-container']}>
          {!isEditOrCreate && requestAttributeList?.length > 0 && (
          <CILabel id="" labelText={String(translate('service_operation_form.request_attribute_lbl'))} />
          )}
          {(isEditOrCreate) && (
          <>
            <Input
              type="text"
              placeholder={String(translate('service_operation_form.request_attribute_value'))}
              label=""
              className={classes['encryption-field-input']}
              name="requestAttributes"
              value={serviceOpsFormData.requestAttributes.value}
              onChange={handleInputChange}
              maxLength={Number.MAX_SAFE_INTEGER}
              error={requestAttributeInvalidity}
              data-testid="request-attribute"
              disabled={!isEditOrCreate}
              labelText={String(translate('service_operation_form.request_attribute_lbl'))}
              errorTxt={formData.requestInputErr}
            />

            <Button
              variant="secondary"
              className={requestAttributeInvalidity ? classes['input-btn-diabled'] : classes['input-btn-enabled']}
              onClick={onRequestAddClickHandler}
              disabled={formData.requestBtnInvalid}
              data-testid="request-attribute-btn"
            >
              {translate('multi_form_modal_component.btn_add')}
            </Button>
          </>
            )}
        </div>
        {requestAttributeList.map((item, index) => (
          <RequestResponseItems
            key={item}
            item={item}
            index={index}
            isEditOrCreate={isEditOrCreate}
            onDeleteHandler={onRequestDeleteHandler}
          />
        ))}
        <div className={classes['encryption-field-input-container']}>
          {!isEditOrCreate && responseAttributeList?.length > 0 && (
          <CILabel id="" labelText={String(translate('service_operation_form.response_attribute_lbl'))} />
          )}
          {(isEditOrCreate) && (
          <>
            <Input
              type="text"
              placeholder={String(translate('service_operation_form.response_attribute_value'))}
              label=""
              className={classes['encryption-field-input']}
              name="responseAttributes"
              value={serviceOpsFormData.responseAttributes.value}
              onChange={handleInputChange}
              error={responseAttributeInvalidity}
              data-testid="response-attribute"
              disabled={!isEditOrCreate}
              labelText={String(translate('service_operation_form.response_attribute_lbl'))}
              errorTxt={formData.responseInputErr}
              maxLength={Number.MAX_SAFE_INTEGER}
            />
            <Button
              variant="secondary"
              className={responseAttributeInvalidity ? classes['input-btn-diabled'] : classes['input-btn-enabled']}
              onClick={onResponseAddClickHandler}
              disabled={formData.responseBtnInvalid}
              data-testid="response-attribute-btn"
            >
              {translate('multi_form_modal_component.btn_add')}
            </Button>
          </>
            )}
        </div>
        {responseAttributeList.map((item, index) => (
          <RequestResponseItems
            key={item}
            item={item}
            index={index}
            isEditOrCreate={isEditOrCreate}
            onDeleteHandler={onResponseDeleteHandler}
          />
        ))}
      </>
    );
};
